import { SxProps, Theme } from "@mui/material";

// Main Container Styles
export const mainContainerStyles: SxProps<Theme> = {
  mt: 2,
};

// Form Grid Styles
export const formGridStyles: SxProps<Theme> = {
  mb: 2,
};

// Process Sections Container
export const processSectionsContainerStyles: SxProps<Theme> = {
  mb: 3,
};

// Section Title Styles
export const sectionTitleStyles: SxProps<Theme> = {
  mb: 2,
};

// Accordion Styles
export const accordionStyles: SxProps<Theme> = {
  mb: 1,
};

export const accordionSummaryStyles: SxProps<Theme> = {
  "& .MuiAccordionSummary-content": {
    alignItems: "center",
  },
};

export const accordionContentStyles: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 1,
  width: "100%",
};

// Section Content Styles
export const sectionContentStyles: SxProps<Theme> = {
  pl: 4,
};

// Stages Container Styles
export const stagesContainerStyles: SxProps<Theme> = {
  mt: 2,
};

export const stagesTitleStyles: SxProps<Theme> = {
  mb: 1,
  fontWeight: "bold",
};

// Stage Accordion Styles
export const stageAccordionStyles: SxProps<Theme> = {
  mb: 1,
  boxShadow: 1,
};

// New Stage Form Styles
export const newStageFormStyles: SxProps<Theme> = {
  mt: 2,
};

export const newStageAccordionStyles: SxProps<Theme> = {
  mb: 1,
  boxShadow: 1,
  border: "2px dashed #1976d2",
};

// Reason Solutions Container Styles
export const reasonSolutionsContainerStyles: SxProps<Theme> = {
  mb: 2,
};

export const reasonSolutionsTitleStyles: SxProps<Theme> = {
  mb: 1,
  fontWeight: "bold",
};

// Reason Solution Item Styles
export const reasonSolutionItemStyles: SxProps<Theme> = {
  mb: 1,
  p: 1,
  border: "1px solid #e0e0e0",
  borderRadius: 1,
};

export const reasonSolutionContentStyles: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 1,
  flexWrap: "wrap",
};

export const reasonSolutionRowStyles: SxProps<Theme> = {
  fontWeight: "bold",
  minWidth: 60,
};

export const reasonSolutionTextStyles: SxProps<Theme> = {
  flexGrow: 1,
  minWidth: 150,
};

export const reasonSolutionSecondaryTextStyles: SxProps<Theme> = {
  color: "text.secondary",
};

export const reasonSolutionCaptionStyles: SxProps<Theme> = {
  minWidth: 100,
};

// Form Styles
export const newReasonSolutionFormStyles: SxProps<Theme> = {
  mb: 2,
  p: 2,
  border: "2px dashed #9c27b0",
  borderRadius: 1,
};

export const editReasonSolutionFormStyles: SxProps<Theme> = {
  mb: 2,
  p: 2,
  border: "2px dashed #ff9800",
  borderRadius: 1,
};

export const formTitleStyles: SxProps<Theme> = {
  mb: 2,
  fontWeight: "bold",
};

export const formContentStyles: SxProps<Theme> = {
  display: "flex",
  gap: 1,
  alignItems: "center",
  flexWrap: "wrap",
};

// Input Field Styles
export const numberInputStyles: SxProps<Theme> = {
  width: 80,
};

export const textInputStyles: SxProps<Theme> = {
  flexGrow: 1,
};

export const textInputWithMinWidthStyles: SxProps<Theme> = {
  flexGrow: 1,
  minWidth: 200,
};

export const previousReasonInputStyles: SxProps<Theme> = {
  width: 150,
};

// Button Styles
export const buttonStyles: SxProps<Theme> = {
  minWidth: 80,
};

export const submitButtonContainerStyles: SxProps<Theme> = {
  mt: 3,
  display: "flex",
  justifyContent: "flex-end",
  gap: 2,
};

export const submitButtonStyles: SxProps<Theme> = {
  minWidth: 120,
};

// Error Styles
export const errorTextStyles: SxProps<Theme> = {
  mt: 1,
  display: "block",
};

// Checkbox Styles
export const checkboxStyles: SxProps<Theme> = {
  ml: 1,
};
